// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInMixin {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOutMixin {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.CreateNicheDashboardModal {
  display: flex;
  flex-direction: column;
  row-gap: 32px;
  width: 488px;
}
.CreateNicheDashboardModal .CreateNicheDashboardModal-nicheList {
  height: 196px;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}
.CreateNicheDashboardModal .CreateNicheDashboardModal-nicheList::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
.CreateNicheDashboardModal .CreateNicheDashboardModal-nicheList::-webkit-scrollbar-track {
  background: transparent;
}
.CreateNicheDashboardModal .CreateNicheDashboardModal-nicheList::-webkit-scrollbar-thumb {
  background: var(--color_neutral_200);
  height: 80px;
  border-radius: 50px;
}
.CreateNicheDashboardModal .CreateNicheDashboardModal-nicheList:hover::-webkit-scrollbar-thumb {
  background: var(--color_neutral_400);
}
.CreateNicheDashboardModal .CreateNicheDashboardModal-nicheList::-webkit-scrollbar-thumb:active {
  background: var(--color_neutral_500);
}
.CreateNicheDashboardModal h3 {
  font-weight: 400;
  color: var(--color_neutral_900);
  margin-bottom: 4px;
}
.CreateNicheDashboardModal .CreateNicheDashboardModal-description {
  color: var(--color_neutral_800);
  font-size: 14px;
  font-weight: 400;
}
.CreateNicheDashboardModal .CreateNicheDashboardModal-dashboardType {
  font-weight: 700;
  font-size: 16px;
  color: var(--color_neutral_900);
  margin-bottom: 16px;
}
.CreateNicheDashboardModal .CreateNicheDashboardModal-buttonsSection {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  column-gap: 16px;
}`, "",{"version":3,"sources":["webpack://./src/mixins.scss","webpack://./src/modules/niche/create-niche-dashboard-modal/create-niche-dashboard-modal.styles.scss"],"names":[],"mappings":"AAwCA;EACE;IACE,UAAA;ECvCF;EDyCA;IACE,UAAA;ECvCF;AACF;AD0CA;EACE;IACE,UAAA;ECxCF;ED0CA;IACE,UAAA;ECxCF;AACF;AAbA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;AAeF;AAbE;EACE,aAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AAeJ;ADdE;EACE,UAAA;EACA,WAAA;ACgBJ;ADbE;EACE,uBAAA;ACeJ;ADZE;EACE,oCAdM;EAeN,YAAA;EACA,mBAAA;ACcJ;ADVI;EACE,oCApBS;ACgCf;ADRE;EACE,oCAxBY;ACkChB;AA5BE;EACE,gBAAA;EACA,+BAAA;EACA,kBAAA;AA8BJ;AA3BE;EACE,+BAAA;EACA,eAAA;EACA,gBAAA;AA6BJ;AA1BE;EACE,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,mBAAA;AA4BJ;AAzBE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AA2BJ","sourcesContent":["@mixin line-clamp($lines, $wordBreak: break-word) {\n  display: -webkit-box;\n  line-clamp: $lines;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: $wordBreak;\n}\n\n@mixin scrollbar(\n  $color: var(--color_neutral_200),\n  $colorHover: var(--color_neutral_400),\n  $colorActive: var(--color_neutral_500)\n) {\n  &::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $color;\n    height: 80px;\n    border-radius: 50px;\n  }\n\n  &:hover {\n    &::-webkit-scrollbar-thumb {\n      background: $colorHover;\n    }\n  }\n\n  &::-webkit-scrollbar-thumb:active {\n    background: $colorActive;\n  }\n}\n\n@keyframes fadeInMixin {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOutMixin {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@mixin fadeIn($timing, $length, $delay, $fill) {\n  animation: fadeInMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin fadeOut($timing, $length, $delay, $fill) {\n  animation: fadeOutMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin noise {\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: -1;\n    background-image: url('./assets/images/png/noise.png');\n    background-position: 0% 0%;\n    background-size: 36.23046875px 36.23046875px;\n    background-repeat: repeat;\n    border-radius: 12px;\n    opacity: 0.3;\n  }\n}\n\n@mixin scoped-excluded($selector, $exclude-class) {\n  :is(#{$selector}):not(:where(#{$exclude-class} *)) {\n    @content;\n  }\n}\n","@import 'src/mixins';\n\n.CreateNicheDashboardModal {\n  display: flex;\n  flex-direction: column;\n  row-gap: 32px;\n  width: 488px;\n\n  .CreateNicheDashboardModal-nicheList {\n    height: 196px;\n    overflow-y: scroll;\n    display: flex;\n    flex-direction: column;\n    row-gap: 10px;\n\n    @include scrollbar;\n  }\n\n  h3 {\n    font-weight: 400;\n    color: var(--color_neutral_900);\n    margin-bottom: 4px;\n  }\n\n  .CreateNicheDashboardModal-description {\n    color: var(--color_neutral_800);\n    font-size: 14px;\n    font-weight: 400;\n  }\n\n  .CreateNicheDashboardModal-dashboardType {\n    font-weight: 700;\n    font-size: 16px;\n    color: var(--color_neutral_900);\n    margin-bottom: 16px;\n  }\n\n  .CreateNicheDashboardModal-buttonsSection {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    column-gap: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
